import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiListResponseModel, ApiService } from "../core";
import { LocationGridAccountItemGetDto, LocationGridAdminFilterPostDtoGridRequestDto } from "../dto";

@Injectable()
export class LocationsService {
  protected serviceUrl = "locations";

  constructor(protected api: ApiService) {}

  getAccountGridData(
    filter: LocationGridAdminFilterPostDtoGridRequestDto
  ): Observable<ApiListResponseModel<LocationGridAccountItemGetDto[]>> {
    return this.api.postList(`${this.serviceUrl}/grid/account`, filter);
  }
}
